const Resources = {

    table_headers: [
        { 
            text: 'Description',
            align: 'start',
            value: 'description'
        },
        { 
            text: 'Rooms',
            value: 'room_counter'
        },
        { 
            text: 'Task',
            value: 'task'
        },
        { 
            text: 'Status',
            value: 'status'
        },
        { 
            text: 'Sun',
            value: 'sunday'
        },
        { 
            text: 'Mon',
            value: 'monday'
        },
        { 
            text: 'Tue',
            value: 'tuesday'
        },
        { 
            text: 'Wed',
            value: 'wednesday'
        },
        { 
            text: 'Thu',
            value: 'thursday'
        },
        { 
            text: 'Fri',
            value: 'friday'
        },
        { 
            text: 'Sat',
            value: 'saturday'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Daily Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

}

export default Resources;